export default __webpack_public_path__ + "static/discovery-d325723557725071567480080c7e4b19.png";